// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'
import { registerPolarisControllers } from 'polaris-view-components'

import AutoSubmit from '@stimulus-components/auto-submit'
import FlatpickrController from './flatpickr_controller'
import FormController from './form_controller'
import RadioSelectController from './radio_select_controller'
import SelectController from './select_controller'
import ToggleButtonController from './toggle_button_controller'
import TomSelectController from './tom_select_controller'
import SortableController from './sortable_controller'
import FlashController from './flash_controller'
import PipelinesController from './pipelines_controller'
import SearchController from './search_controller'
import CkeditorController from './ckeditor_controller'
import CodeHighlightController from './code_highlight_controller'
import selectAllController from './selectall_controller'
import ClipboardController from './clipboard_controller'
import CarouselController from './carousel_controller'
import ConfettiController from './confetti_controller'
import EmailsController from './emails_controller'
import CallsController from './calls_controller'
import ShortcutController from './shortcut_controller'
import QuickSearchController from './quick_search_controller'
import PeopleLoader from './people_loader_controller'

registerPolarisControllers(application)
application.register('flatpickr', FlatpickrController)
application.register('form', FormController)
application.register('radio-select', RadioSelectController)
application.register('select', SelectController)
application.register('toggle-button', ToggleButtonController)
application.register('tom-select', TomSelectController)
application.register('auto-submit', AutoSubmit)
application.register('sortable', SortableController)
application.register('flash', FlashController)
application.register('pipelines', PipelinesController)
application.register('search', SearchController)
application.register('ckeditor', CkeditorController)
application.register('code-highlight', CodeHighlightController)
application.register('selectall', selectAllController)
application.register('clipboard', ClipboardController)
application.register('carousel', CarouselController)
application.register('confetti', ConfettiController)
application.register('emails', EmailsController)
application.register('calls', CallsController)
application.register('shortcut', ShortcutController)
application.register('quick-search', QuickSearchController)
application.register('people-loader', PeopleLoader)
